var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.1 4.4a5 5 0 1 1-5.2 8.4 5 5 0 0 0 5.2-8.3m-4.7 3.7.6-1.8-1.5 1.1h1.8l-1.5-1zm0-2.6.6-1.7-1.5 1h1.8l-1.5-1zM28 6.8l.6-1.7-1.5 1h1.8l-1.5-1zm-5 2.6.5-1.8-1.5 1h1.9l-1.5-1zm2.5 1.2.5-1.7-1.4 1h1.8l-1.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "M7.5 0h10.9v40H7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M10.2 0h-.4l-.7.6L9 .4V0h-.5l-.8.8v.3h.4V.9l.2.2-.4.4.2.2-.7.5v.4l1-1-.1-.1.4-.4-.3-.4.2-.2.4.4zM7.6 0v.7l.2-.2V.2H8l.3-.2zm1.9 0h-.3v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M10.1 0h-.3l-.7.6-.3-.3h.3V.1h-.4l-.8.8V1h.3V.8l.3.3-.5.4.2.2-.6.6v.3l1-1-.3-.1.5-.4-.4-.3.3-.3.4.4zM7.5 0v.7l.2-.2V.2H8l.2-.2zm2 0h-.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M7.5 4.6V5l.6.6-.2.2.5.4-.2.2V6h-.4v.3l.8.8h.5V7h-.3l.3-.2.7.6L9 8l-.3-.2H9v-.4h-.5l-.8.9v.3h.4v-.3l.2.2-.5.4.3.2-.7.5v.4l1-1-.1-.1.4-.4-.3-.4.2-.2.4.4 1-1-1-.9-.4.4-.2-.2.3-.3-.4-.4.2-.2zm0 2V8l.3-.2v-.3H8l.2-.2L8 7h-.2v-.3zm1.8.5v.4l.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M7.5 4.7V5l.7.6-.2.2.4.4-.3.2v-.3h-.3v.3l.8.8H9V7h-.2l.3-.4.7.7-.7.6-.3-.3h.3v-.2h-.5l-.8.7v.3h.3v-.3l.3.3-.4.4.2.2-.7.6v.3l1-1-.2-.1.4-.4-.3-.4.3-.3.4.5 1-1-1-.8-.5.4-.2-.3.3-.3-.4-.4.2-.2zm0 1.9V8l.2-.2v-.3H8l.2-.2L8 7h-.3v-.3zm1.8.5v.3l.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M7.5 12.2v.4l.6.6-.2.2.5.3-.2.2v-.2h-.4v.3l.8.7h.5v-.2h-.3l.3-.3.7.6-.7.7-.3-.3h.3v-.3h-.5l-.8.8v.3h.4v-.2l.2.1-.5.4.3.2-.7.6v.4l1-1-.1-.2.4-.4-.3-.3.2-.3.4.4 1-.9-1-1-.4.5-.2-.2.3-.4-.4-.4.2-.2zm0 1.9v1.4l.3-.2V15H8l.2-.2-.2-.2h-.2v-.3zm1.8.5v.4l.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M7.5 12.2v.3l.7.6-.2.2.4.4-.2.3v-.3h-.4v.3l.8.7H9v-.2h-.2l.3-.3.7.6-.7.6-.3-.3h.3V15h-.5l-.8.8v.2h.3v-.3l.3.3-.4.4.2.2-.7.6v.3l1-1-.2-.1.4-.4-.3-.3.3-.3.4.4 1-.9-1-.9-.5.5-.2-.3.3-.3-.4-.4.2-.2zm0 1.9v1.4l.2-.2V15H8l.2-.2-.2-.2h-.3v-.3zm1.8.5v.3l.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M7.5 19.7v.4l.6.5-.2.2.5.4-.2.2v-.2h-.4v.3l.8.7h.5V22h-.3l.3-.3.7.6-.7.6-.3-.2h.3v-.3h-.5l-.8.8v.3h.4v-.2l.2.1-.5.4.3.2-.7.6v.4l1-1-.1-.2.4-.4-.3-.3.2-.3.4.5 1-1-1-1-.4.5-.2-.2.3-.4-.4-.4.2-.2zm0 1.9V23l.3-.3v-.3H8l.2-.2L8 22h-.2v-.3zm1.8.5v.4l.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M7.5 19.7v.3l.7.7-.2.1.4.4-.3.3v-.3h-.3v.3l.8.7H9V22h-.2l.3-.3.7.6-.7.7-.3-.4h.3v-.2h-.5l-.8.8v.3h.3V23l.3.3-.4.4.2.2-.7.6v.3l1-.9-.2-.2.4-.4-.3-.3.3-.3.4.4 1-.9-1-.9-.5.5-.2-.3.3-.3-.4-.5.2-.2zm0 2V23l.2-.2v-.3H8l.2-.2-.2-.2h-.3v-.3zm1.8.5v.3l.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M7.5 27.2v.4l.6.6-.2.2.5.4-.2.1v-.2h-.4v.3l.8.8h.5v-.3h-.3l.3-.3.7.7-.7.6-.3-.3h.3V30h-.5l-.8.8v.3h.4v-.3l.2.2-.5.4.3.2-.7.6v.4l1-1-.1-.2.4-.4-.3-.3.2-.2.4.4 1-1-1-.9-.4.4-.2-.2.3-.3-.4-.5.2-.1zm0 1.9v1.5l.3-.3v-.2H8l.2-.3-.2-.2h-.2v-.3zm1.8.5v.4l.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M7.5 27.3v.3l.7.6-.2.2.4.4-.3.2v-.3h-.3v.3l.8.7H9v-.2h-.2l.3-.3.7.6-.7.7-.3-.3h.3V30h-.5l-.8.7v.3h.3v-.3l.3.2-.4.5.2.1-.7.7v.3l1-1-.2-.2.4-.4-.3-.3.3-.3.4.4 1-.9-1-.9-.5.5-.2-.3.3-.3-.4-.5.2-.1zm0 1.8v1.4l.2-.1V30H8l.2-.2-.2-.2h-.3v-.3zm1.8.6v.3l.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M15.7 0h.4l.6.6.3-.3h-.2V.1h.4l.9.7v.3h-.4V1l-.2.2.4.3-.2.2.6.6v.4l-1-1 .2-.2-.4-.3.3-.4-.2-.2-.5.4zm2.7 0v.7L18 .5V.2h-.2l-.3-.2zm-2 0h.2v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M15.8 0h.2l.7.6.4-.3h-.3V.1h.4l.8.8V1h-.3V.8l-.2.3.4.4-.2.2.6.6v.3l-1-1 .3-.1L17 1l.4-.3-.3-.3-.4.4zm2.5 0v.7l-.2-.2V.2h-.3l-.1-.2zm-1.9 0h.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M18.4 4.6V5l-.7.6.2.2-.4.4.2.2V6h.4v.3l-.9.8h-.4V7h.2l-.2-.2-.7.6.6.6.3-.2h-.2v-.4h.4l.9.9v.3h-.4v-.3l-.2.2.4.4-.2.2.6.5v.4l-1-1 .2-.1-.4-.4.3-.4-.2-.2-.5.4-1-1 1-.9.5.4.2-.2-.3-.3.4-.4-.2-.2zm0 2V8l-.3-.2v-.3h-.2l-.3-.2.3-.2h.2v-.3zm-1.8.5v.4l-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M18.4 4.7V5l-.7.6.2.2-.5.4.3.2V6h.3v.3l-.8.8h-.4v-.3h.3l-.4-.3-.7.6.7.7.3-.3h-.2v-.2h.4l.8.7v.3h-.3V8l-.3.3.5.3-.2.2.6.6v.4l-1-1 .2-.2-.4-.3.4-.4-.4-.3-.4.5-1-1 1-.9.5.5.3-.3-.4-.3.4-.4-.2-.2zm0 1.9V8l-.3-.2v-.3H18l-.2-.2.2-.2h.2v-.3zm-1.8.5v.3l-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M18.4 12.2v.4l-.7.6.2.2-.4.3.2.2v-.2h.4v.3l-.9.7h-.4v-.2h.2l-.3-.3-.6.6.6.6.3-.2h-.2v-.3h.4l.9.8v.3h-.4v-.3l-.2.2.4.4-.2.2.6.5v.4l-1-.9.2-.2-.4-.4.3-.3-.2-.3-.5.4-1-.9 1-1 .5.5.2-.2-.3-.4.4-.4-.2-.2zm0 1.9v1.4l-.3-.2V15h-.2l-.3-.2.3-.2h.2v-.3zm-1.8.5v.4l-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M18.4 12.2v.3l-.7.6.2.2-.4.4.2.3v-.4h.3v.3l-.8.8h-.4v-.2h.3l-.4-.3-.7.6.7.7.3-.3h-.2v-.3h.4l.8.8v.3h-.3v-.3l-.3.2.5.4-.2.2.6.6v.3l-1-.9.2-.2-.4-.4.4-.3-.4-.3-.4.4-1-.9 1-.9.5.5.3-.3-.4-.3.4-.5-.2-.1zm0 1.9v1.4l-.3-.2V15H18l-.2-.2.2-.2h.2v-.3zm-1.8.5v.3l-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M18.4 19.7v.4l-.7.5.2.2-.4.4.2.2v-.2h.4v.3l-.9.7h-.4V22h.2l-.2-.3-.7.6.6.6.3-.2h-.2v-.3h.4l.9.8v.3h-.4v-.2l-.2.1.4.4-.2.2.6.6v.4l-1-1 .2-.2-.4-.4.3-.3-.2-.3-.5.5-1-1 1-1 .5.5.2-.2-.3-.3.4-.5-.2-.2zm0 1.9V23l-.3-.3v-.3h-.2l-.3-.2.3-.2h.2v-.3zm-1.8.5v.4l-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M18.4 19.7v.3l-.7.7.2.1-.4.4.2.3v-.3h.3v.3l-.8.7h-.4V22h.3l-.4-.3-.7.6.8.7.3-.4h-.3v-.2h.4l.8.8v.3h-.3V23l-.2.3.4.4-.2.2.6.6v.3l-1-.9.3-.2-.5-.4.4-.3-.3-.3-.4.4-1-.9 1-.9.4.5.3-.3-.4-.3.5-.5-.3-.2zm0 2V23l-.3-.2v-.3H18l-.2-.2.2-.2h.2v-.3zm-1.8.5v.3l-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M18.4 27.2v.4l-.7.6.2.2-.4.4.2.1v-.2h.4v.3l-.9.8h-.4v-.3h.2l-.2-.3-.7.7.6.6.3-.3h-.2V30h.4l.9.8v.3h-.4v-.3l-.2.2.4.4-.2.2.6.6v.4l-1-1 .2-.2-.4-.4.3-.3-.2-.2-.5.4-1-1 1-.9.5.4.2-.2-.3-.3.4-.5-.2-.1zm0 1.9v1.5l-.3-.3v-.2h-.2l-.3-.3.3-.2h.2v-.3zm-1.8.5v.4l-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M18.4 27.3v.3l-.7.6.2.2-.5.4.3.2v-.3h.3v.3l-.8.7h-.4v-.2h.3l-.4-.3-.7.6.7.7.3-.3h-.2V30h.4l.8.7v.3h-.3v-.3l-.3.2.5.5-.2.1.6.7v.3l-1-1 .2-.2-.4-.4.4-.3-.4-.3-.4.4-1-.9 1-.9.5.5.3-.3-.4-.3.4-.5-.2-.1zm0 1.8v1.4l-.3-.1V30H18l-.2-.2.2-.2h.2v-.3zm-1.8.6v.3l-.2-.2zm-8.2 5.7.3.6.1-.7-.2-.5q-.2.2-.2.6m0 1q.2.3.6.4v-.4q.3-.3.1-.6l-.1.3-.2.4-.2-.3-.5-.5q0 .5.3.6m.8.6v.3l-.4-.3-.5-.4.3.6.7.4.1-.6v-.5zm.5.7.2.4-.6-.3-.7-.3a1 1 0 0 0 .7.7l.9.2q0-.4-.3-.7l-.2-.4zm.8.6.3.3-.9-.2h-.6q.4.4.8.4h1.1l-.4-.5q-.2-.4-.6-.4zm1 .5L10 39q1 .4 1.9 0l.8-.1q.6 0 1.4.7l.2-.2a3 3 0 0 0-2.6-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M8.9 4.7 8 4.2V2.9l.9-.5v-.7l.8-.5h.7l1.2-.7h2.7l1.2.7h.6l1 .5v.7l.8.5v1.3l-.9.5v.7l-.8.5h-.7l-1.2.7h-2.7l-1.2-.7h-.7L9 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "m11.6.5-1.2.7h-.7l-.8.5v.7l-.9.5v1.3l.9.5v.7l.8.4h.7l1.2.7h2.7l1.2-.7h.6l.9-.4v-.7l.8-.5V2.9l-.8-.5v-.7l-.9-.5h-.6L14.3.5zm0 .3h2.6l1.3.7h.6l.6.3v.7l.9.6V4l-1 .5v.7l-.5.4h-.6l-1.3.7h-2.5l-1.3-.7h-.6L9 5.2v-.7L8.3 4V3l.9-.5v-.7l.6-.3h.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M13 3.5V.8h-1.3l-1.3.7h-.6l-.6.3v.7l-.9.6v.4zv2.7h1.3l1.3-.7h.6l.5-.3v-.7l1-.5v-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.3 3.5V4l1 .5v.7l.5.3h.6l1.3.7h1.2V3.5h4.6v-.4l-.9-.6V2l-.5-.4h-.6L14.2.8h-1.3v2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "m10.2 1.8-.2-.3-.2.2.2.2-.3.1h.7l.4.5.2-.1-.5-.5v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "m11.2 1.7-.2-.2-.2.1.2.2-.3.2h.7l.5.5.1-.2-.4-.5v-.3zm-1 .6-.3-.2-.2.2.2.2-.2.1h.6l.5.5.1-.2-.5-.4V2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M13 .8h-.6l-.3.2h-.5l-.4.3v.2l.4-.2h.2l.5.6.6-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m10 1.6.2.2H10l-.2-.1zm.5 0V2l.5.5h-.1l-.5-.4h-.6zm.5 0h.2l-.2.2zm.5 0v.2l.5.5-.1.1-.5-.5h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m10 2.2.1.1-.1.1-.2-.1zm.4 0v.3l.5.4-.1.2-.5-.5h-.5zM13 .8h-.5l-.3.3h-.5l-.4.2v.1l.4-.2h.2l.5.7.6-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "m10.2 5.3-.2.2-.2-.1.2-.2-.3-.2h.7l.4-.5.2.2-.5.5v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "m11.2 5.4-.2.2-.2-.2.2-.1-.3-.2h.7l.5-.5.1.2-.4.4v.3zm-1-.7-.3.2-.2-.1.2-.2-.2-.2h.6l.5-.5.1.2-.5.5v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M13 6.3h-.6l-.3-.3h-.5l-.4-.2v-.3l.4.2h.2l.5-.6.7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m10 5.4.2-.1-.2-.1-.2.2zm.5 0v-.3l.5-.4-.1-.2-.5.5h-.6zm.5.1.2-.1-.2-.1zm.5 0v-.3l.5-.4-.1-.2-.5.5h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m10 4.9.1-.2-.1-.1-.2.2zm.4 0v-.3L11 4l-.1-.1-.5.4h-.5zM13 6.1h-.5l-.3-.3h-.5l-.4-.1v-.2l.4.2h.2l.5-.7.6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M9.9 2.6h-.3l-.3.2-.6.7.6.7.3.3h.3l-.2-.2V4h.4V3h-.4v-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m9.3 2.8.3-.2h.2l-.1.1V3h.3v1h-.3v.3h.1l-.2.2-.3-.3-.5-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "m15.6 1.8.3-.3.2.2-.2.2.2.1h-.6l-.5.5-.2-.1.6-.5v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "m14.6 1.7.3-.2.1.1-.1.2.2.2h-.6l-.5.5-.2-.2.5-.5v-.3zm1.1.6.2-.2.2.2-.2.2.3.1h-.6l-.5.5L15 3l.5-.5v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M13 .8h.5l.3.2h.5l.4.3v.2l-.4-.2H14l-.6.6-.6-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m15.9 1.6-.2.2h.1zm-.5 0V2l-.5.5h.1l.5-.4h.5zm-.6 0h-.2l.2.2.2-.2zm-.5 0v.2l-.4.5.1.1.5-.5h.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m16 2.2-.3.1.2.1zm-.5 0v.3l-.6.4.2.2.5-.5h.5zM12.9.8h.6l.3.3h.5l.4.2-.1.2-.3-.2H14l-.6.6-.6-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "m15.6 5.3.3.2.2-.1-.2-.2.2-.2h-.6l-.5-.5-.2.2.6.5v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "m14.6 5.4.3.2.1-.2-.1-.1.2-.2h-.6l-.5-.5-.2.2.5.4v.3zm1.1-.7.2.2.2-.1-.2-.2.3-.2h-.6L15 4l-.2.2.5.5V5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M13 6.3h.5l.3-.3h.5l.4-.2v-.3l-.4.2H14l-.6-.6-.6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m15.9 5.4-.2-.2h.1zm-.5 0v-.3l-.5-.4.1-.2.5.5h.5zm-.5.1-.2-.1.1-.1zm-.5 0v-.3l-.5-.4.1-.1.5.4h.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m16 4.9-.3-.2.2-.1zm-.5 0v-.3l-.6-.5.2-.1.5.4h.5zm-2.6 1.3h.6l.3-.3h.5l.4-.1-.1-.2-.3.2H14l-.6-.7-.6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M16 2.6h.2l.4.2.5.7-.5.7-.3.3H16l.1-.2V4h-.3V3h.3v-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m16.6 2.8-.4-.2h-.1V3h-.3v1h.3v.3l.1.2.4-.3.5-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M9.4 4 9 3.4l.3-.3V3l.1-.1.3.2h-.2l.3.2h.4l.5-.3v-.8h1l1.1-.8v-.1l-.2-.1-.2.1v.1l-.2-.2.4-.3.3-.2h.1l.3.2h.1l.3.3-.1.2-.3-.2H13v.3l1.1.7h1V3l.4.3h.5l.2-.2.2-.2V3l.4.5-.3.3V4l-.1.1-.3-.2h.1l-.2-.2h-.5l-.4.3v.8h-1l-1.2.7v.2l.2.1h.3v-.2l.1.2-.3.3-.3.2h-.2l-.3-.2-.4-.3.2-.2v.1l.3.1h.2v-.3l-1.2-.7h-1V4l-.4-.3h-.5zh.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M13 5.8V6zm-.4.2.3.2V6h-.2l.2-.2v-.4l-1.2-.7h-1v-.8l-.4-.4h-.7l-.2.2-.2-.2H9l.3.4.1.2.2-.2.1-.3h.6l.4.3v.9h1l1.1.7v.2l-.2.1-.2-.1h-.2zM9.4 3.3l.1.2h-.2zM13 1v.2zm3.4 2.6h.3zm-3-2.6L13 .8V1l.1.1-.2.2v.3l1.3.7h1v.9l.4.3h.7l.2-.2.1.2h.3l-.3-.3V3l-.1-.1-.2.1-.2.3h-.5l-.4-.3v-.8h-1L13 1.6v-.2l.2-.2h.1l.2.2.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 6h-.2l.1-.2zM9.4 3.5v.2l-.3-.2zM13.3 6l-.3.2V6h.1l-.2-.2v-.4l1.3-.7h1v-.8l.4-.4h.7l.2.2.1-.2h.3l-.3.4-.1.2-.2-.2-.2-.3h-.5l-.4.3v.9h-1l-1.2.7v.2l.2.1.3-.1zm3.2-2.7-.2.2h.3zm-4-2.3.4-.2V1l-.2.1.2.2v.3l-1.2.7h-1v.9l-.4.3h-.7l-.2-.2-.2.2H9l.3-.3V3l.1-.1.2.1.1.3h.6l.4-.3v-.8h1l1.2-.7v-.2l-.2-.2h-.1l-.2.2-.1-.1zm.4.3.2-.1-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M13 3.5V1.6l-1.3.8h-1v.8l-.3.3zv1.9l1.3-.8h.9V4l.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m10.4 3.5.4.4v.7h.9l1.2.8V3.5h2.6l-.4-.4v-.7h-1L13 1.6v2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "m11.6 2.6-.2-.2-.2.2.2.1-.3.2h.6l.5.5.2-.2-.5-.5v-.3zm2.7 1.8.2.2.2-.1-.2-.2.2-.2h-.5l-.5-.4-.2.1.5.5v.3zm-2.7 0-.2.2-.2-.1.2-.2-.3-.2h.6l.5-.4.2.1-.5.5v.3zm2.7-1.8.2-.2.2.2-.2.1.2.2h-.5l-.5.5-.2-.2.5-.5v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m14.5 4.6-.2-.2h.1l.2.1zm-.5 0v-.3l-.5-.5.1-.1.5.5h.5zm-2.6-2.1.2.1-.2.1-.2-.1zm.4 0v.3l.5.4v.1l-.6-.4h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "m14.5 2.5-.2.1.1.1.2-.1zm-.5 0v.3l-.5.4.1.1.5-.4h.5zm-2.6 2.1.2-.2h-.2l-.2.1zm.4 0v-.3l.5-.5-.6.4h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "m14.3 3.5-1.4 1-1.3-1 1.3-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13 2.7-1.3.8h2.5zm0 0v1.6l1.2-.8h-2.5l1.2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M13.3 3.8v.3h-.7v-.3h-.4v-.6h.4V3h.7v.2h.4v.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "M12.6 3v.3h-.4v.2h.7V3zm.3.5h.8v-.2h-.4V3h-.4zm-.7 0v.3h.4V4h.3v-.5zm.7.5h.3v-.2h.5v-.3H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M15.2 13.6v-.4h1v-.4h1.1V9.3h-1v-.4h-1.1v-.4h-1v-.4h-2.5v.4h-1v.4H9.6v.4h-1v3.5h1v.4h1v.3h1.1v.4h2.4v-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M11.8 8.2v.3h-1v.4H9.6v.4h-1v3.5h1v.3h1v.5h1.1v.3H14v-.4h1.1v-.3h1v-.4h1.1V9.3h-1v-.4H15v-.4h-1v-.3zm.3.2h1.7v.4h1v.4H16v.4h1v2.9h-1v.4h-1.1v.3h-1v.4H12v-.4h-1V13h-1v-.4H8.8v-3h1v-.4h1v-.4H12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "M11 13.2V13h-1v-.4H8.8v-3h1v-.4H11V9h1.1v-.4h1.7v.3h1v.4H16v.4h1v2.8h-1v.4h-1.2v.4h-1v.4H12v-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M11.3 9.1 11 9v.4l-.3.2v-.3l-.2.3-.3-.3v.3l-.3-.2v.4l-.2.2v-.3l-.3.2-.3-.2v.3l-.3-.2v1h-.3v.6h.3v1.1l.3-.2v.3l.3-.2.3.2v-.2l.2.1v.4l.3-.2v.3l.3-.3.2.3v-.3l.3.2v.4l.3-.3v.3l.2-.2.3.2V13l.2.2v.4l.4-.3v.4l.5-.3.5.3v-.4l.4.3v-.4l.3-.2v.3l.2-.2.3.2V13l.3.2v-.4l.2-.1v.2l.3-.2.2.2v-.2l.3.2v-.4l.3-.2v.3l.3-.2.2.2v-.3l.3.2v-1h.3v-.6H17v-1l-.3.1v-.2l-.2.2-.3-.2v.2l-.2-.2v-.3l-.4.1v-.2l-.2.2-.3-.2v.2l-.2-.1V9l-.3.3V9l-.3.2L14 9v.3l-.2-.2v-.4l-.4.3v-.4l-.5.3-.5-.3v.3l-.4-.3V9l-.2.2v-.3l-.3.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M9.1 10v-.3l.3.2.3-.2v.2l.2-.2v2.7l-.2-.2v.2l-.3-.2-.2.2v-.2l-.3.2v-1.1h-.3v-.5h.3V9.7zm2.2-1 .3.1.2-.2v.3L12 9v4l-.3-.1v.3l-.2-.2-.3.2v-.3l-.3.2v-4l.3.1zm3.3 0-.2.1L14 9v.3l-.3-.2v4l.3-.1v.3l.3-.2.2.2V13l.3.2v-4l-.3.1zm2.1 1v-.3l-.2.2-.3-.2v.2l-.2-.2v2.7l.2-.2v.2l.3-.2.2.2v-.2l.3.2v-1.1h.3v-.5H17V9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "m10.3 9.3.2.2.2-.2v.2l.3-.1v3.3l-.3-.2v.3l-.2-.2-.2.2v-.3l-.4.2V9.4l.4.1zm2.2-.4-.4-.3v5l.4-.4v.3l.4-.3.5.3v-.4l.4.3V8.6l-.4.3v-.4l-.5.3-.4-.3zm3.1.4-.2.2-.2-.2v.2l-.3-.1v3.3l.3-.2v.3l.2-.2.2.2v-.3l.3.2V9.4l-.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M9.3 10.6h.2l.1-.5-.1.2v-.2l-.2.2-.1-.2zm1.1-.3V10l-.3.2.3.3.4-.3-.2-.2v.2-.2l.1-.2-.2-.2-.2.2.1.2zm1-.3v-.3l-.2.2.4.3.3-.3-.2-.2v.2-.3l-.1-.3-.3.2.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.4 10.2h.2v.2a.1.1 0 0 1-.3 0v-.3.1zm2.2-.6v.4l.1-.1v-.1h.1l-.3.4-.3-.3.2-.1v.3-.5l.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "M10.5 10v.3h.2V10v.1l-.2.3-.3-.3V10v.1l.2.1zl-.1-.2.2-.1.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M16.6 10.6h-.2q-.2-.2-.2-.5l.2.2v-.2l.2.2v-.2zm-1.1-.3V10l.2.2-.3.3-.4-.3.2-.2v.2h.1V10l-.1-.2.2-.2.2.2-.1.2zm-1-.3v-.3l.2.2-.3.3-.4-.3.2-.2v.2-.3l.2-.3.2.2-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.5 10.2-.1.1h-.1v.2a.1.1 0 0 0 .3 0zm-2.2-.6v.4l-.1-.1v-.1H14l.3.4.4-.3-.2-.1-.1.3zl-.2-.2-.1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "M15.4 10v.3h-.2V10v.1l.2.3.3-.3-.1-.1v.1l-.1.1zv-.2l-.1-.1-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "m13.3 10 .2-.3-.2-.2v.2h-.1v-.2l.2-.2-.5-.4-.4.3.2.3v.2-.2l-.4.2.3.3v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m12.6 10-.2-.3.2-.1.1.2v-.3l-.2-.2.4-.3.4.3-.2.2v.4l.2-.2h.2l-.3.3.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "m12.7 9.2.2.2.3-.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M13 9v.2h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M9.3 11.5h.2l.1.4h-.4zm1.1.3v.3l-.3-.2.3-.3.4.3-.2.2v-.2.2l.1.2-.2.1-.2-.2.1-.1zm1 .3v.3l-.2-.2.4-.3.3.3-.2.2v-.2.3l-.1.3-.3-.2.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.4 11.9v-.2l.2.2v-.3a.1.1 0 0 0-.3 0v.3-.2zm2.2.6V12l.1.1v.2l.1-.2-.3-.3-.3.3.2.2V12v.4l.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "M10.5 12.1v-.3h.2v.2-.1l-.2-.3-.3.3v.1-.1l.2-.2zl-.1.2h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M16.6 11.5h-.2l-.2.4h.4zm-1.1.3v.3l.2-.2-.3-.3-.4.3.2.2v-.2h.1v.2l-.1.2.2.1.2-.2-.1-.1zm-1 .3v.3l.2-.2-.3-.3-.4.3.2.2v-.2.3l.2.3.2-.2-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.5 11.9-.1-.2-.1.2v-.3a.1.1 0 0 1 .3 0zv-.2zm-2.2.6V12l-.1.1v.2l-.2-.2.3-.3.4.3-.2.2v-.2l-.1-.1zl-.2.2-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "M15.4 12.1v-.3h-.2v.2-.1l.2-.3.3.3-.1.1v-.1l-.1-.2zv.2h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M13.3 12v.2l.2.2-.2.3v-.2h-.1v.2l.2.2-.5.3-.4-.3.2-.2v-.3.3l-.4-.2.3-.3V12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "M12.6 12v.2l-.2.2.2.2v-.1l.1-.2v.4l-.2.2.4.3.4-.3-.2-.2v-.3l.2.1v.1l.2-.2-.3-.2.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "m12.7 13 .2-.3.3.2-.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M13 13v-.2h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M16.7 10.9h-.4v-.2h-1.5l-1-.6h-1.7l-1 .6H9.6v.2H9v.3h.5v.2H11l1 .7h1.8l1-.7h1.5v-.2h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m12 10-1 .7H9.7v.2h-.4v.3h.4v.2H11l1 .6h1.8l1-.6h1.4v-.2h.5v-.3h-.4v-.2h-1.5l-1-.6zm0 .2h1.8l1 .6h1v.4h-1.1v.1l-1 .6h-1.6l-1-.6h-1v-.4h1v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m13.8 10.2.9.6h1v.4h-1v.1l-1 .6h-1.6l-.9-.6h-1v-.4h1v-.1l.9-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "m11.6 11.4.4.3.3-.2-.2-.1h-.2l1.5-1.1H13zm.9.4h.3l1.4-1-.3-.4-.3.2.2.1h.1zm.6 0h.3l-1.5-1 .1-.2.2.1-.2-.3-.4.3zm.8-.4h-.3l.2.3.4-.3-1.4-1.1h-.3zm-2.5-.3.2.1.3-.1-.3-.2zm1.3 0 .2.1.3-.1-.3-.2zm1.8 0-.2.1-.3-.1.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "m14.2 11.4-.3.2-.3-.1.2-.1h.2l-1.4-1.1h.2zm-.9.4h-.2l-1.4-1 .3-.3.2.1H12l-.1.1zm-.5 0h-.2l1.4-1-.2-.2h-.2l.3-.2.3.3zm.3-1.5h.2l-1.4 1 .1.2.2-.1-.2.2-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "m11.6 10.9.2.2h-.4zm1.3 0 .3.2h-.5zm1.4 0-.2.2h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "m8.4 18.3-.1.1.2.2-.2.1v.1h.5l.5.2v-.2l-.3-.2.3-.2V18l-.5.3-.2-.1zm0-1-.1.2.2.1-.2.2.3.1.2-.1.5.3v-.3l-.3-.2.3-.2v-.3l-.5.3h-.4m0 2.5-.1-.2.2-.1-.2-.1v-.2h.3l.2.1.5-.3v.3l-.3.2.3.2v.3l-.5-.4-.2.2zm9.1-1.5.1.1-.2.2.2.1-.1.1h-.4l-.5.2v-.2l.3-.2-.3-.2V18l.5.3.2-.1zm0-1 .1.2-.2.1.2.2h-.1l-.2.1-.2-.1-.5.3v-.3l.3-.2-.3-.2v-.3l.5.3h.4m0 2.5.1-.2-.2-.1.2-.1-.1-.2h-.2l-.2.1-.6-.3v.3l.4.2-.3.2v.3l.5-.4.2.2zm-2-4v.3h.2v.2h.3V16h-.2v-.2zm.8.6v.3h.3v.2h.2v-.4h-.2v-.1zm-5.9-.6v.3h-.3v.2h-.3V16h.3v-.2zm5 5.6V21h.6v.3h-.2v.3zm-5 0V21h-.6v.3h.3v.3zm5.9-.6v-.4h.3v-.2h.2v.3h-.2v.3zm-6.7-4.4v.3h-.3v.2H9v-.4h.3v-.1zm0 4.4v-.4h-.3v-.1H9v.3h.3v.2zm4.4-5-.2-.3-.2.2.1.2-.2.2h.3l.2-.1v.1h.5l-.2-.2.1-.2-.2-.2zm-1 0-.3-.3-.2.2.2.2-.2.2h.3l.1-.1.2.1h.3l-.2-.2.2-.2-.2-.2zm-1.1 0 .2-.3.2.2-.2.2.3.2H12zl-.1.1h-.5l.3-.2-.2-.2.2-.2zm2 5.6-.1.3-.2-.2.1-.2-.2-.3h.3l.2.2V21h.5l-.2.3.1.1-.2.3zm-1 0-.2.3-.2-.2.2-.2-.2-.3h.3l.1.2.2-.2h.3l-.2.3.2.1-.2.3zm-1 0 .2.3.2-.2-.2-.2.3-.3H12l-.1.2-.1-.2h-.5l.3.3-.2.1.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M9.3 18.8v.2l-.5-.3-.2.1h-.3l.2-.2-.2-.2.1-.1h.2l.2.2.5-.4v.2l-.4.3zm0-1v.3l-.5-.4-.2.2h-.2l-.1-.1.2-.2-.2-.1.1-.1h.2l.2.1.5-.3v.2l-.4.2zm0 1.5V19l-.5.3-.2-.2h-.2l-.1.1.2.2-.2.1.1.1h.4l.5.2v-.2l-.4-.2zm7.3-.5v.2l.5-.3.2.1h.2l-.1-.2.2-.2-.1-.1h-.2l-.2.2-.5-.4v.2l.4.3zm0-1v.3l.5-.4.2.2h.2v-.1l-.1-.2.2-.1-.1-.1h-.2l-.2.1-.5-.3v.2l.4.2zm0 1.5V19l.5.3.2-.2h.2v.1l-.1.2.2.1-.1.1H17l-.5.2v-.2l.4-.2zm-.8-3.6v.3h.2v.3h-.2V16h-.3v-.4zm.8.7v.2h.2v.3h-.2v-.2h-.3v-.3zm-6.5-.6v.2h-.3v.3h.3V16h.3v-.4zm5.7 5.6V21h.2v-.2h-.2v.1h-.3v.3zm-5.6 0V21h-.3v-.2h.2v.1h.3v.3zm6.4-.6v-.3h.2v-.2h-.2v.1h-.3v.4zm-7.3-4.4v.2h-.2v.3h.2v-.2h.3v-.3zm0 4.4v-.3h-.2v-.2h.2v.2h.3v.3zm4.5-5.2.2.2.2-.2.2.1-.2.2.2.2h-.3L14 16h-.4.2l-.2-.3zm-1 0 .1.2.3-.2.1.1-.2.2.2.2h-.2l-.2-.1h-.4.2l-.1-.3zm-.7 0-.2.2-.2-.2-.2.1.2.2-.2.2h.2l.2-.1h.4-.2l.2-.3zm1.7 6 .2-.2.2.2.2-.2-.2-.1.2-.2h-.3l-.1.1-.2-.1h-.2l.2.2-.2.1zm-1 0 .1-.2.3.2.1-.2-.2-.1.2-.2h-.2l-.2.1v-.1h-.4l.2.2-.1.1zm-.7 0-.2-.2-.2.2-.2-.2.2-.1-.2-.2h.2l.2.1.1-.1h.3l-.2.2.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M10.1 20.4v.7h5.7v-.7h.8v-3.7h-.8V16H10v.6h-.8v3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M10.1 16v.7h-.8v3.7h.8v.6h5.7v-.6h.8v-3.7h-.8V16zm.4.3h4.9v.6l.2.2h.7v3h-.9v.7h-4.9v-.6l-.2-.2h-.8v-3h1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "M10.5 16.4v.5l.8-.5zm4.1 0 .7.5v-.5zm-5 .7v.5l.7-.5zm6 0 .7.5v-.5zm.7 2.4-.7.5h.7zm-6.7 0v.5h.7zm1 .7v.6h.7zm4.7 0-.7.6h.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "m14.6 16.4 1.7 1.2v1.9l-1.7 1.2h-3.3l-1.7-1.2v-1.9l1.7-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "m10 19.7-.2-.3.2-.2-.2-.2.2-.2-.2-.2.2-.3-.2-.2.2-.2-.2-.2.2-.2h5.9l.2.2-.2.2.2.2-.2.2.2.3-.2.2.2.2-.2.2.2.2-.2.3zm4-3-.2-.3-.2.2-.2-.2-.2.2-.3-.2-.2.2-.2-.2-.2.2-.2-.2-.3.3v3.7l.3.3.2-.2.2.2.2-.2.2.2.3-.2.2.2.2-.2.2.2.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "m13.6 16.7-.2-.2-.2.2v3.7l.2.2.2-.2zm-.9 0-.2-.2-.2.2v3.7l.2.2.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "m10 19.7-.2-.3.2-.2h6l.2.2-.2.3zm5.9-1.3.2.2-.2.2H10l-.2-.2.2-.2zm0-.5.2-.2-.2-.2H10l-.2.2.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m14 16.7-.2-.2-.2.2v3.7l.2.2.2-.2zm-1.7 0-.2-.2-.2.2v3.7l.2.2.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m10 19.2-.2-.2.2-.2h6l.2.2-.2.2zm0-.9-.2-.2.2-.2h6l.2.2-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m13.2 20.5-.3.1-.2-.2v-3.7l.2-.2.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M15 16.7h-4v.3h-.6v3h.5v.4h4V20h.6v-3h-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "M11 16.8v.3h-.5v3h.5v.3h.4l-.9-.7v-2.2l.9-.7zm3.5 0 .8.7v2.2l-.8.6h.4V20h.5v-3H15v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "m11.4 16.8-.8.7v2.1l.8.8h3l.9-.7v-2.2l-.9-.7zm0 0h3l.8.7v2l-.8.7h-3l-.7-.6v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M12.2 19.6h.2v.3h-.2l.3.3h-.3l-.1-.2-.2.2h-.2l.2-.2-.2-.2v-.1h.5m.9 0h.1v.3h-.1l.2.3h-.2l-.2-.2-.1.2h-.2l.2-.2-.2-.2v-.1h.5m.5 0v.3h.1l-.2.3h.2l.2-.2.1.2h.3l-.3-.2.2-.2v-.1h-.5m-1.3-2.1.1-.2-.2-.2.3-.2h-.2l-.2.2-.2-.2h-.2l.2.2-.2.2v.1l.2.1.2-.1zm.8 0h.1v-.2l-.1-.2.3-.2H13l-.2.2-.1-.2h-.2l.2.2-.2.2v.1l.2.1.1-.1zm.5 0-.1-.2.1-.2-.2-.2h.2l.2.2.1-.2h.3l-.2.2.1.2v.1l-.2.1-.1-.1zm1.6.2-.2.2h.2v.2l-.3-.1-.1.1h-.2V18l.1-.1-.1-.2v-.1h.2l.1.1.3-.1zm0 .8H15l.2.2v.1l-.3-.1h-.3l.1-.2h-.1v-.2h.2l.1.1.3-.1zm0 .9-.2-.1.2-.2V19l-.3.1h-.3l.1.2h-.1v.2h.2l.1-.1.3.2zM10.8 18l.2.2h-.2v.2l.3-.1v.1h.2l.1-.1-.1-.1.1-.2v-.1H11zl-.3-.1zm0 .8h.2l-.2.2v.1l.3-.1h.3l-.1-.2h.1v-.2H11zl-.3-.1zm0 .9.2-.1-.2-.2V19l.3.1h.3l-.1.2h.1v.2H11l-.1-.1-.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m11.5 17-.7.5.1.2.2-.1h.2v.1l-.1.2h.1v.2h-.6v.1l.2.2.1-.1h.2l.1.1-.1.2h.1v.2H11l-.3.1.2.2.1-.1h.2l.1.1-.1.2.1.1v.1h-.6l.8.7h.1l.3-.2-.2-.2v-.2h.2l.2.1.1-.1h.2v.2l-.2.2.3.2.2-.2-.1-.2v-.2h.1l.2.1.2-.1h.1v.2l-.1.2.2.2.3-.2-.2-.2v-.2h.2l.2.1.1-.1h.2v.2l-.2.2.3.2h.2l.7-.6-.2-.2-.1.2h-.2V19l.2-.1v.1l.3-.2-.2-.2-.1.1h-.2v-.5h.5v-.1L15 18l-.1.1h-.2v-.4l.2-.1v.1l.3-.2-.7-.6h-.2l-.2.2.1.2v.2h-.7v-.2l.2-.2-.2-.2-.3.2.2.2v.2h-.7v-.2l.1-.2-.2-.2-.2.2.1.2v.2h-.7v-.2l.2-.2-.3-.2zm-.8 1.5v.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 20v.2h.2zm1 0-.2.2h.3zm.8 0-.1.2h.2zm-1.9-3h.3zm1 0h.2zm.8 0h.2zm1.4.8v.1zm0 .7v.1zm0 .7v.1m-4.4-1.4v.1h.1zm0 .7v.1h.1zm0 .7v.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M13.7 18.3v-.2h-.3v-.3h-1v.3h-.2v.2H12v.5h.3v.3h.3v.2h1V19h.2v-.2h.3v-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M13 17.8v.3l-.5.2v.3H12v-.2h.3V18h.3v-.3zm0 1.5V19l.3-.2v-.2h.7v.2h-.3v.2h-.3v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.3 18.6v-.3l-.4-.2v-.3h.5v.3h.2v.3h.4v.2zm-1.4 0h.6v.2l.4.2v.3h-.4V19h-.3v-.2H12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "M12.6 18.6v.2l.3.2v-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "m13 18.1-.4.3v.2h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "M13.3 18.6v-.2L13 18v.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "m13 19 .3-.2v-.2H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "M9.5 23.6v.8h-.7v.7H8v2h.8v.7h.7v.8h2.7l.5.3-.3.1h-1 1l-.3-.3h-1.3l.6.6h1.1l.4-.3.4.2h1.2l.6-.6h-1.3l-.2.3h.8-1.2l.5-.4h2.7v-.7h.7V27h.7v-2h-.7v-.7h-.7v-.8h-2.7l-.5-.3.2-.1h1-.8l.2.3h1.3l-.6-.6h-1.2l-.4.3-.4-.3h-1.1l-.6.6H12l.2-.2h-.9v-.1h1l.3.1-.5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M13.7 28.5h2.6v-.7h.7V27h.8v-2H17v-.7h-.7v-.8h-2.7l-1.1-.7h-1.1l-.5.6H12l.2-.2h-.8V23h1l1.3.8h2.4v.8h.7v.7h.8v1.4h-.8v.7h-.7v.8h-2.3l-1.3.7h-1l-.1-.1h.8l-.2-.2h-1l.5.5h1.1zm-1.6-.2H9.8v-.8h-.7v-.7h-.8v-1.4h.8v-.7h.7v-.8H12l1.2-.7h1l.2.1h-.9l.2.2H15l-.5-.6h-1.2l-1 .7H9.4v.8h-.7v.7H8v2h.7v.7h.8v.7h2.7l1 .7h1.2l.5-.5h-1.2l-.1.2h.8l-.1.1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M15.8 27.3v.7h-2.1l-.8.5-.7-.5H10v-.7h-.7v-.7h-.8v-1h.8V25h.7v-1h2.2l.7-.4.8.4h2.1v.8h.7v.7h.8v1h-.7v.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M10.3 27v.7h1.2zm0-1.8v-.8h1.2zm5.3 1.8v.7h-1.2zm0-1.8v-.8h-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m10.4 27 1 .7h-1zm0-1.9 1-.7h-1zm5.1 2-1 .6h1zm0-2-1-.7h1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M11.8 25.9v-.4l-.7-.4-.7.4v.4H10v.4h.3v.4h.1l.7.4.6-.4h.1v-.4h.5v-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m11 25.1.7.4h-1.2zm.7 1.6-.7.3-.5-.3zm-.2-.8v.4h-.7v-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M11.8 26.3v.3h-.7v-.3zm-.7 0v.3h-.8v-.3zm1.1-.4v.4h-.6v-.4zm-1.4 0v.4H10v-.4zm1-.4v.4h-.7v-.4zm-.7 0v.4h-.8v-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M10.6 26v.2h-.4V26zm.3-.4v.2h-.4v-.2zm.7 0v.2h-.3v-.2zm-.3.4v.2H11V26zm.7 0v.2h-.3V26zm-.4.4v.2h-.3v-.2zm-.7 0v.2h-.4v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.5 26h-.3v.1h.3m.4-.4h-.4v.2h.4zm.7 0h-.3v.2h.3zm-.3.4H11v.1h.3m.7 0h-.2v.1h.2m-.4.4h-.3v.1h.3zm-.8 0h-.2v.1h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M14 25.9v-.4h.2l.6-.4.6.4h.2v.4h.3v.4h-.3v.4h-.1l-.7.4-.6-.4H14v-.4h-.5v-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "m14.8 25.1-.6.4h1.2zm-.6 1.6.6.3.6-.3zm.1-.8v.4h.7v-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M14 26.3v.3h.8v-.3zm.8 0v.3h.8v-.3zm-1.2-.4v.4h.8v-.4zm1.5 0v.4h.7v-.4zm-1-.4v.4h.7v-.4zm.7 0v.4h.8v-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M15.3 26v.2h.3V26zm-.3-.4v.2h.3v-.2zm-.7 0v.2h.3v-.2zm.3.4v.2h.3V26zm-.8 0v.2h.3V26zm.5.4v.2h.3v-.2zm.7 0v.2h.3v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.3 26h.3v.1h-.3m-.3-.4h.3v.2H15zm-.7 0h.3v.2h-.3zm.3.4h.3v.1h-.3m-.7 0h.2v.1h-.2m.4.4h.3v.1h-.3zm.7 0h.3v.1H15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M13.7 25.2v.4h-.1l-.7.4-.6-.4h-.1v-.4h-.4v-.4h.4v-.4h.1l.6-.4.7.4v.4h.5v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "m13 26 .5-.4h-1.1zm.5-1.6-.6-.3-.5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "M13.7 24.8v-.4H13v.4zm-.8 0v-.4h-.7v.4zm1.1.4v-.3h-.7v.3zm-.7 0v-.3h-.7v.3zm-.7 0v-.3h-.8v.3zm1 .4v-.4H13v.4zm-.7 0v-.4h-.7v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M12.7 24.5v.2h-.3v-.1zm.8 0v.2h-.3v-.1zm-1.2.4v.2H12V25zm.8 0v.2h-.3V25zm.7 0v.2h-.3V25zm-1 .4v.2h-.4v-.2zm.7 0v.2h-.3v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.7 24.6h-.3zm.7 0h-.2zm-1 .3H12v.2h.2zm.7 0h-.3v.2h.3zm.7 0h-.2v.2h.2zm-1.1.4h-.3v.2h.3zm.7 0h-.2v.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M13.7 27.3v.4h-.1l-.7.4-.6-.4h-.1v-.4h-.4V27h.4v-.3h.1l.6-.5.7.5v.3h.5v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "m13 28 .5-.2h-1.1zm.5-1.5-.6-.3-.5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "M13.7 27v-.4H13v.3zm-.8 0v-.4h-.7v.3zm1.1.3V27h-.7v.3zm-.7 0V27h-.7v.3zm-.7 0V27h-.8v.3zm1 .4v-.4H13v.4zm-.7 0v-.4h-.7v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M12.7 26.6v.3h-.3v-.3zm.8 0v.3h-.3v-.3zm-1.2.5v.2H12V27zm.8 0v.2h-.3V27zm.7 0v.2h-.3V27zm-1 .3v.2h-.4v-.2zm.7 0v.2h-.3v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.7 26.7h-.3v.1h.3zm.7 0h-.2v.1h.2zm-1 .4H12v.1h.2zm.7 0h-.3v.1zm.7 0h-.2v.1zm-1.1.4h-.3zm.7 0h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "m8.8 32 2.9-1.5h2.5L17 32v2.5l-2.8 1.4h-2.5l-2.9-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M11.7 30.5 8.9 32v2.4l2.8 1.5h2.5l2.8-1.5V32l-2.8-1.5zm0 .2h2.5l2.6 1.4v2.2l-2.6 1.4h-2.5l-2.6-1.4v-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M13 33.2v2.5h1.2l2.6-1.4v-1zv-2.6h-1.2L9 32.1v1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 33.2v2.5h-1.3L9 34.3v-1zv-2.6h1.3l2.6 1.4v1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M13.2 35.6v-.8l-.3.2-.2-.2v.8H12l.5-.4v-.5l-.8-.5h-.5v-2h.5l.7-.5v-.5l-.4-.4h.8v.8l.2-.2.2.2v-.7h.8l-.6.3v.5l.8.5h.5v2h-.5l-.7.5v.5l.4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M13.2 30.9v.7l-.3-.1v.2l1.2.7h.4v.8h.2v-1h-.5l-.8-.5v-.5l.4-.3zm-2 2.3v1h.5l.8.5v.5l-.5.3h.7v-.7l.2.1v-.2l-1.2-.7h-.3v-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12 30.9.5.3v.6l-.8.4h-.5v1h.2v-.8h.4l1.1-.7v-.2l-.2.1V31zm2.5 2.3v.8H14l-1.2.7v.2l.3-.1v.7h.6l-.4-.3v-.6l.8-.5h.5v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "M11.4 34h.4l1.1.7 1.2-.7h.3v-1.6h-.3l-1.2-.7-1.1.7h-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M13.7 33.6h.3v-.1h-.2v-.3h.4v.6h-.4v.3H13v-.5h.4v.2h-.2v.1h.4v-.2l-1.5-.9H12v.1h.2v.3h-.4v-.6h.4v-.4h.7v.6h-.3v-.2h.1v-.1h-.3v.2zm-.1-1v-.1h-.3v.3H13v-.5h.8v.3h.4v.6h-.4v-.3h.2-.3l-1.4.8v.2h.3v-.1h-.1v-.2h.3v.5h-.7v-.4h-.4v-.5h.4v.2h-.2v.1h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.6 33.7v.3h-.3v-.4h-.2v.5h.7v-.4h.4v-.5h-.3v.2h.1v.2h-.2l-1.5-1v-.2h.4v.2h-.1v.1h.3v-.4H12v.4h-.4v.4h.4V33h-.2v-.2h.3zm.1-.9h.3v.2h-.2v.1h.4v-.4h-.4v-.4h-.7v.5h.3v-.2h-.2v-.1h.5zl-1.5 1h-.3v-.3h.2v-.1h-.3v.4h.3v.4h.7v-.5h-.2v.4h-.3v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383739",
    d: "M16.2 33.3v.8H16v-.3h-.3v.3h-.4v-.8h.3v.3h.4v-.3zm-1.2 1v.9h-.3v-.3h-.3v.3H14v-.8h.3v.2h.4v-.2zm1.2-1.2v-.8H16v.3h-.3v-.3h-.4v.8h.3v-.3h.4v.3zm-6.5.2v.8h.3v-.3h.3v.3h.4v-.8h-.3v.3H10v-.3zm0-.2v-.8h.3v.3h.3v-.3h.4v.8h-.3v-.3H10v.3zm5.3-1v-.9h-.3v.3h-.3v-.2H14v.7h.3v-.2h.4v.3zm-4 2.2v.8h.3v-.3h.3v.3h.4v-.8h-.3v.2h-.4v-.2zm0-2.4v-.8h.3v.3h.3v-.2h.4v.7h-.3v-.2h-.4v.3zm4.3-.5v.6h1.1zm-4.5 3.4v-.6H9.6zm0-3.4v.6H9.6zm4.5 3.4v-.6h1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22630",
    d: "M15.9 33.8v.3h.3v-.7h-.3v.2h-.4v-.2h-.3v.7h.3v-.3zm-1.2 1v.4h.3v-.8h-.3v.3h-.4v-.3H14v.7h.3v-.3zm1.2-2.2v-.3h.3v.7h-.3v-.2h-.4v.3h-.3v-.8h.3v.3zm-6 1.2v.3h-.2v-.7h.3v.2h.3v-.2h.4v.7h-.3v-.3zm0-1.2v-.3h-.2v.7h.3v-.2h.3v.3h.4v-.8h-.3v.3zm4.8-1v-.3h.3v.7h-.3zh-.4v.3H14v-.7h.3v.3zm-3.5 3.2v.4h-.3v-.8h.3v.3h.4v-.3h.3v.7h-.3v-.3zm0-3.2v-.3h-.3v.7h.3zh.4v.3h.3v-.7h-.3v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "M15.2 31.5v.6h1zm-5.5 2.9.9.5v-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.6 31.5-1 .6h1zm4.6 2.9v.5l1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc72c",
    d: "m17.5 35.4-.3.6q-.2-.3-.1-.7l.2-.5q.3.2.2.6m0 1q-.2.3-.6.4l-.1-.4q-.2-.3 0-.6v.3q.3.1.3.4l.2-.3q0-.2.4-.5 0 .5-.2.6m-.8.6v.3l.4-.3.4-.4-.3.6-.6.4-.2-.6.2-.5zm-.5.7-.2.4.6-.3.7-.3q-.2.6-.8.7l-.8.2.2-.7.2-.4zm-.8.6-.3.3.9-.2h.5q-.3.4-.7.4h-1.1l.4-.5q.2-.4.6-.4zm-1.1.5 1.6.2q-.9.4-1.8 0l-.9-.1q-.5 0-1.3.7l-.2-.2q1.2-.9 2.6-.6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTm);
export default __webpack_public_path__ + "static/media/tm.08ccd87a450de5cd9b3ef67446aa4e0b.svg";
export { ForwardRef as ReactComponent };